module.exports = __webpack_public_path__ + "static/media/store-apoteka.rs.e940213d.png";